import { TextField } from '@material-ui/core';
import React from 'react';

/**
 * @param {import('@material-ui/core').TextFieldProps} props
 */
export default function TextFilter(props) {
  return (
    <TextField
      variant="outlined"
      color="primary"
      size="small"
      fullWidth
      InputLabelProps={{
        shrink: true
      }}
      {...props}
    />
  );
}